export const hosts = {
  prod: "fleet.uptake.com",
  staging: "fleet-stg01.uptake.com",
  dev: "fleet-dev01.uptake.com",
  local: "localhost",
};
